import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../../queries/withCount';

const ERRORS = `errors { path, message }`;

const SELLER_USER_FIELDS = `
  id
  firstName
  lastName
  fullName
  email
  assetNotifications
  role
  invitationSentAt
  invitationAcceptedAt
  seller {
    id,
    name,
    street,
    city,
    state,
    postalCode { formatted, value}
    phoneNumber { formatted, value}
  }
  contact {
    id
    firstName
    lastName
    title
    email
    phoneNumber { formatted, value }
    sellerUser { id }
  }
`

const SELLER_USER_VARIABLES = `
  $sellerId: ID!
  $contactId: ID
  $email: String!
  $firstName: String!
  $lastName: String!
  $role: String!
  $assetNotifications: String
`;

const SELLER_USER_ARGUMENTS = `
  sellerId: $sellerId
  contactId: $contactId
  email: $email
  firstName: $firstName
  lastName: $lastName
  role: $role
  assetNotifications: $assetNotifications
`;

const EDIT_SELLER_USER_VARIABLES = `
  $id: ID!
  $email: String!
  $firstName: String!
  $lastName: String!
  $role: String
  $assetNotifications: String
`;

const EDIT_SELLER_USER_ARGUMENTS = `
  id: $id
  email: $email
  firstName: $firstName
  lastName: $lastName
  role: $role
  assetNotifications: $assetNotifications
`;

const SELLER_USER_FIELDS_AND_ERRORS = `
  sellerUser {
    ${SELLER_USER_FIELDS}
  }
  ${ERRORS}
`;

export const SELLER_USERS_WITH_COUNT = gql`
  query (
    ${WITH_COUNT_VARIABLES}
    $sellerId: ID!
  ) {
    sellerUsersWithCount(
      ${WITH_COUNT_ARGUMENTS}
      sellerId: $sellerId
    ) {
      entries {
        ${SELLER_USER_FIELDS}
      }
      count
    }
  }
`;

export const CREATE_SELLER_USER = gql`
  mutation CreateSellerUser(
    ${SELLER_USER_VARIABLES}
  ) {
    createSellerUser(
      ${SELLER_USER_ARGUMENTS}
    ) {
      ${SELLER_USER_FIELDS_AND_ERRORS}
      acceptUrl
    }
  }
`;

export const UPDATE_SELLER_USER = gql`
  mutation UpdateSellerUser(
    ${EDIT_SELLER_USER_VARIABLES}
  ) {
    updateSellerUser(
      ${EDIT_SELLER_USER_ARGUMENTS}
    ) {
      ${SELLER_USER_FIELDS_AND_ERRORS}
    }
  }
`;

export const SELLER_USER = gql`
  query SellerUser($id: ID!) {
    sellerUser(id: $id) {
      ${SELLER_USER_FIELDS}
    }
  }
`;

export const HIDE_SELLER_USER = gql`
  mutation HideSellerUser($id: ID!) {
    hideSellerUser(id: $id) {
      sellerUser {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

export const UNHIDE_SELLER_USER = gql`
  mutation UnhideSellerUser($id: ID!) {
    unhideSellerUser(id: $id) {
      sellerUser {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

export const REINVITE_SELLER_USER = gql`
  mutation ReinviteSellerUser(
    $id: ID!
  ) {
    reinviteSellerUser(
      id: $id
    ) {
      sellerUser { id }
      errors { message, path }
    }
  }
`;

